import Services from '../Service'

class ConfService extends Services {
  constructor() {
    super()
    this.resource = 'conf'
  }

  async uploadCapa(payload) {
    const requestUrl = `${this.resource}/upload-capa`
    return await this._http.post('conf/upload-capa', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  async getCapas() {
    const requestUrl = `${this.resource}/capas`
    return await this.getAPI(requestUrl)
  }

  async uploadFundo(payload) {
    return await this._http.post('conf/upload-fundo', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  async getFundos() {
    const requestUrl = `${this.resource}/fundos`
    return await this.getAPI(requestUrl)
  }

  // `deleteAPI()` da classe base nao serve: ela monta `${resource}/${id}`, e
  // aqui o backend precisa dos dois campos (tipo + filename).
  async deleteImagem(tipo, filename) {
    try {
      const { data } = await this._http.delete(`${this.resource}/imagem`, {
        data: { tipo, filename },
      })
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }
}

export default new ConfService()
